import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer";
import PageTopMenu from "../../../Containers/PageTopMenu";
import VocabTestPage from "../Vocab/Exam";

class VocabTest extends Component {
    render() {
        return (
            <div className="beaconWrapper">
                <Header />
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <h2 className="screenOut">오늘의 Vocabulary 시험</h2>
                        <PageTopMenu />
                        <div className="pageContents">
                            <VocabTestPage categoryName="vocabulary"/>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default VocabTest;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Exam/index.js